import { computed, reactive, ref } from "vue";
import { defineStore } from "pinia";
import { appTheme, COLOR_THEME_VARS } from "../constants/appTheme";
import status from "../constants/statuses";

export const useApplicationStore = defineStore("application", () => {
    const THEME_STORAGE_KEY = "app_theme";

    // State
    const themeMode = ref(appTheme.light);
    const statusState = ref(status.success);
    const isOpenChat = ref(false);
    const isOpenedWidget = ref(false);
    const isOpenPopupWidget = ref(false);
    const categoryPath = ref("");
    const chunkLoadError = ref(false);
    const profileLoadError = ref(false);
    const projectInfo = reactive({
        id: import.meta.env.VITE_PROJECT_ID,
        name: import.meta.env.VITE_PROJECT_NAME,
        domain: import.meta.env.VITE_MAIN_DOMAIN,
    });
    const statusStore = reactive({
        router: status.empty,
    });

    // Getters
    const getThemeMode = computed(() => themeMode.value);
    const getIsOpenChat = computed(() => isOpenChat.value);
    const getIsOpenedWidget = computed(() => isOpenedWidget.value);
    const getIsOpenPopupWidget = computed(() => isOpenPopupWidget.value);
    const getCategoryPath = computed(() => categoryPath.value);
    const getChunkLoadError = computed(() => chunkLoadError.value);
    const isMobile = computed(() => {
        const mobileDevices = [/Android/i, /webOS/i, /iPhone/i, /iPad/i, /iPod/i, /BlackBerry/i, /Windows Phone/i];
        return mobileDevices.some(device => navigator.userAgent.match(device));
    });
    const routerLoading = computed(() => statusStore.router === status.loading);

    // Actions
    function applyTheme(mode) {
        const root = document.documentElement;
        const themeVars = COLOR_THEME_VARS[mode];
        Object.entries(themeVars).forEach(([key, value]) => {
            root.style.setProperty(key, value);
        });
    }

    function setThemeMode(mode) {
        themeMode.value = mode;
        applyTheme(mode);
        localStorage.setItem(THEME_STORAGE_KEY, mode);
    }

    function initTheme() {
        const savedTheme = localStorage.getItem(THEME_STORAGE_KEY);
        if (savedTheme && [appTheme.light, appTheme.dark].includes(savedTheme)) {
            setThemeMode(savedTheme);
        } else {
            setThemeMode(appTheme.light);
        }
    }

    // function setOpenChat(value) {
    //     isOpenChat.value = value;
    // }
    //
    // function setOpenedWidget(value) {
    //     isOpenedWidget.value = value;
    // }
    //
    // function setOpenPopupWidget(value) {
    //     isOpenPopupWidget.value = value;
    // }

    function setStatus(state) {
        statusState.value = state;
        if (state?.type === "router") {
            statusStore.router = state.val;
        }
    }

    function setProfileLoadError(value) {
        profileLoadError.value = value;
    }

    function setCategoryPath(category = "") {
        categoryPath.value = category;
    }

    function setChunkLoadError(value) {
        chunkLoadError.value = value;
    }

    return {
        // State
        themeMode,
        statusState,
        isOpenChat,
        isOpenedWidget,
        isOpenPopupWidget,
        categoryPath,
        chunkLoadError,
        profileLoadError,
        projectInfo,
        statusStore,

        // Getters
        getThemeMode,
        getIsOpenChat,
        getIsOpenedWidget,
        getIsOpenPopupWidget,
        getCategoryPath,
        getChunkLoadError,
        isMobile,
        routerLoading,

        // Actions
        setThemeMode,
        initTheme,
        // setOpenChat,
        // setOpenedWidget,
        // setOpenPopupWidget,
        setStatus,
        setCategoryPath,
        setChunkLoadError,
        setProfileLoadError,
    };
});
